import { rgba } from "./color";

// Core colors
// const colorPrimary = '#673FBD';
// const colorPrimaryDark = '#5629B6';
// const colorSecondary = '#6569DF';
// const colorCoreRed = '#EA475D';
// const colorCoreTeal = '#63D2D6';
// const colorCoreYellow = '#F7CE53';
// const colorCoreGreen = '#3CCC38';
// const colorCoreBlue = '#3B85F4';
// const colorCoreBlack = '#393C40';
// const colorCoreGray = '#888';
// const colorCoreLightGray = '#AAAEB3';

const colorPrimary = "#5E6FF9";
const colorPrimaryDark = "#212557";
const colorSecondary = "#6569DF";
const colorCoreRed = "#EA475D";
const colorCoreTomato = "tomato";
const colorCoreTeal = "#5e9309";
const colorCoreYellow = "#F7CE53";
const colorCoreGreen = "#3CCC38";
const colorCoreBlue = "#3B85F4";
const colorCoreBlack = "#393C40";
const colorCoreGray = "#888";
const colorCoreLightGray = "#AAAEB3";
const colorCorePurple = "#4D528E";
const colorCoreLGray = "#edeaea";

const colorLightGray = "#AAA";
const colorLightGrey = "#EBE7E7";
const colorLightBlue = "#F8FBFF";
const colorCoreDarkGray = "#373737";
const colorShadowGray = "#DDD";

const colorBlack = "#000";
const colorWhite = "#FFF";

// backgrounds
const bgMain = "#EDF1F5";
const bgDark = rgba("#000", 0.95);
const bgLight = "#FAFAFA";
const bgActive = "#F0F0F0";
const bgUnread = "#F7F8FC";
const bgInternal = "#FFFCCC";
const bgOceanBlue = "#477af6";

// Link colors
const linkPrimary = "#1785FC";
const linkPrimaryHover = rgba(linkPrimary, 0.7);

// Border colors
const borderPrimary = "#EEE";
const borderDarker = "#DEE4E7";
const borderPurple = "#4D528E";
const borderOceanBlue = "#477af6";

// Text colors
const textPrimary = "#444";
const textSecondary = rgba(textPrimary, 0.8);
const textOverlay = "#FFF";

// Shadow colors
const shadowPrimary = rgba(colorShadowGray, 0.7);
const darkShadow = rgba(colorBlack, 0.2);

// Social colors
const socialFacebook = "#3A5999";
const socialFacebookMessenger = "#1472FB";
const socialTwitter = "#1DA1F2";

//Theme Colors
const themeBlack = "#303030";
const themeBlue = "#5E6FF9";
// const themeBlue = '#0161ED';

export default {
  colorPrimary,
  colorPrimaryDark,
  colorSecondary,
  colorCoreRed,
  colorCoreTomato,
  colorCoreTeal,
  colorCoreYellow,
  colorCoreBlue,
  colorCoreGreen,
  colorCoreBlack,
  colorCoreGray,
  colorCoreLightGray,
  colorCorePurple,
  colorWhite,
  colorBlack,
  colorShadowGray,
  colorLightGray,
  colorLightBlue,
  colorCoreDarkGray,
  colorCoreLGray,
  colorLightGrey,

  // bgMain,
  bgDark,
  bgLight,
  bgActive,
  bgUnread,
  bgInternal,
  bgOceanBlue,

  linkPrimary,
  linkPrimaryHover,

  borderPrimary,
  borderDarker,
  borderPurple,
  borderOceanBlue,

  textPrimary,
  textSecondary,
  textOverlay,

  shadowPrimary,
  darkShadow,

  socialFacebook,
  socialFacebookMessenger,
  socialTwitter,

  themeBlack,
  themeBlue,
};



// WEBPACK FOOTER //
// ./src/modules/common/styles/colors.js